import { render } from "./AddPobatchLocation.vue?vue&type=template&id=2c8358c7"
import script from "./AddPobatchLocation.vue?vue&type=script&lang=js"
export * from "./AddPobatchLocation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__